import React, { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from 'components/components/atoms';
import ExpansionPanelCrawlerReadable from 'components/components/organisms/ExpansionPanelCrawlerReadable';

const Container = styled.div`
  & > div > div:nth-child(2) {
    z-index: 1;
    height: 100%;
  }
`;

const QuestionsAndAnswers = ({ faqs = [], openOnLanding = false }) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <>
      <Container
        className={cx(
          'w-full md:rounded overflow-hidden relative flex flex-col items-center mt-12 md:mt-16',
        )}
      >
        {faqs.map((e, index) => (
          <div
            className={cx('mb-2 md:mb-4 w-full', {
              hidden: !showAll && index > 3,
            })}
            key={index}
          >
            <ExpansionPanelCrawlerReadable
              text={e.answer}
              title={e.question}
              type='text'
              openOnLanding={openOnLanding}
              compact={true}
            />
          </div>
        ))}
        {!showAll && faqs.length > 4 && (
          <Button
            className={cx('mt-6', {})}
            color={'mattamy-blue'}
            variant='filled'
            buttonDescription={'SHOW MORE'}
            onClick={() => {
              setShowAll(true);
            }}
          >
            <p className='w-40'>{'SHOW ALL'}</p>
          </Button>
        )}
      </Container>
    </>
  );
};

QuestionsAndAnswers.propTypes = {
  faqs: PropTypes.array.isRequired,
};

export default QuestionsAndAnswers;
